import sendApprovalDocToApp from '@/utils/approval/sendApprovalDocToApp';
import { isRnHost } from '@/utils/approval/isInApp';
import { getApprovalCancelCreateUrl } from '@/utils/urls';

/**
 * 앱 채널은 URL 호스트로 정해지므로(포탈 V2 = 포탈 웹뷰, 레거시 = 레거시 웹뷰) 호출부가 tabName 을 고르지 않음.
 * 원 품의가 즉시 취소 대상인지(cancelType) 판정은 호출부 몫 — 여기는 approval 분기에서만 부를 것.
 * 구버전 앱(플래그만 심고 브릿지 없음) 대응 위해 isRnWebView 대신 isRnHost 판정.
 */
const openCancelApprovalCreate = (formType: number, docId: string) => {
  const url = getApprovalCancelCreateUrl(formType, docId);
  if (isRnHost()) {
    sendApprovalDocToApp(url);
    return;
  }
  window.open(url, '_blank', 'noreferrer');
};

export default openCancelApprovalCreate;
